import './compassion/style';
import FormStructure from './compassion/form_structure';

export default FormStructure;